import { useEffect, useState } from "react";

import useService from "../../../../hooks/useService";
import { provider_settlement } from "../../../api/endpoints/provider_settlement";
import {
  mapProviderOption,
  mapSettlementTypeOption,
} from "../components/medical-breakdown/helpers/customMedicalItem";

export default function useCustomMedicalItemOptions({ openModal, providerSearch }) {
  const providerRepository = useService("repositories/provider-repository");
  const [providerOptions, setProviderOptions] = useState([]);
  const [settlementTypeOptions, setSettlementTypeOptions] = useState([]);
  const [isLoadingProviders, setIsLoadingProviders] = useState(false);

  useEffect(() => {
    if (!openModal) {
      return;
    }

    provider_settlement
      .getSettlementType()
      .then((choices) => setSettlementTypeOptions((choices || []).map(mapSettlementTypeOption)))
      .catch(() => setSettlementTypeOptions([]));
  }, [openModal]);

  useEffect(() => {
    if (!openModal) {
      return;
    }

    let active = true;
    const timeoutId = setTimeout(async () => {
      setIsLoadingProviders(true);

      try {
        const response = await providerRepository.getProviders({
          ordering: "name",
          search: providerSearch || undefined,
        });

        if (active) {
          setProviderOptions((response || []).map(mapProviderOption));
        }
      } catch (error) {
        if (active) {
          setProviderOptions([]);
        }
      } finally {
        if (active) {
          setIsLoadingProviders(false);
        }
      }
    }, 250);

    return () => {
      active = false;
      clearTimeout(timeoutId);
    };
  }, [openModal, providerRepository, providerSearch]);

  return {
    providerOptions,
    settlementTypeOptions,
    isLoadingProviders,
  };
}
